import clsx from 'clsx';

import {Text} from '../Text/Text';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  required?: boolean;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  error?: string;
  maxCount?: number;
  onAddValue: () => void;
  children: React.ReactNode;
};
export function MultiTextWrapper({
  label,
  hint,
  error,
  maxCount,
  onAddValue,
  className,
  children,
  required,
  ...props
}: Props): React.JSX.Element {
  return (
    <div {...props} className={clsx(className, 'max-w-lg')}>
      {label && (
        <div className="mb-2 justify-between sm:flex">
          <label className="block text-sm/6 font-medium text-slate12">
            {required && <span className="mr-1 text-tomato11">&#42;</span>}
            {label}
          </label>

          {hint && <span className="text-sm/6 text-slate11">{hint}</span>}
        </div>
      )}

      <div className="space-y-2">{children}</div>

      <div className="mt-2 text-sm">
        <button onClick={onAddValue} type="button">
          <Text as="link" tag="span" className="text-sm">
            + Add another item
          </Text>
        </button>
      </div>

      {error && (
        <div className="mt-2 text-sm">
          <p className="font-medium text-tomato11">{error}</p>
        </div>
      )}
    </div>
  );
}
